export const P0003606PositionTypeEnum = [
  { ref: 0, label: 'P0003606.positiontype.0' },
  { ref: 1, label: 'P0003606.positiontype.1' },
];
